module.exports = __webpack_public_path__ + "static/media/solar_water_heater_on.0f301ea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/solar_water_heater_on.png
// module id = 450
// module chunks = 0